module.exports = __webpack_public_path__ + "static/logo-a5986ce69a6fb752c4a72dc6c4b3c675.svg";